import {IComponentController, IComponentOptions} from "angular";
import {Address} from "../../model/Address";
import {AddressServiceName} from "../../../utils/names/serviceNames";
import './address-form.component.scss';

export class AddressFormComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./address-form.component.html'),
        controller: [AddressServiceName, AddressFormComponent],
        bindings: {
            address: '=',
        }, transclude: {
            controls: 'controls'
        }
    };

    private address: Address;

    $onInit(): void {
        console.log(this.address);
    }


}